var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonefill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75586 12.6885C7.34863 15.29 10.5039 17.2939 13.0791 17.2939C14.2305 17.2939 15.2412 16.8896 16.0498 15.9932C16.5244 15.4658 16.8145 14.8594 16.8145 14.2529C16.8145 13.7871 16.6299 13.3301 16.1816 13.0137L13.4834 11.0977C13.0527 10.7988 12.7012 10.6582 12.3848 10.6582C11.9717 10.6582 11.6025 10.8867 11.1982 11.291L10.5654 11.9238C10.46 12.0205 10.3369 12.0645 10.2227 12.0645C10.082 12.0645 9.9502 12.0117 9.8623 11.959C9.30859 11.6602 8.35938 10.8516 7.48047 9.97266C6.60156 9.09375 5.78418 8.15332 5.49414 7.59082C5.44141 7.49414 5.39746 7.37109 5.39746 7.23047C5.39746 7.125 5.43262 7.00195 5.5293 6.89648L6.16211 6.25488C6.55762 5.8418 6.79492 5.48145 6.79492 5.06836C6.79492 4.74316 6.6543 4.3916 6.35547 3.96973L4.44824 1.29785C4.12305 0.84082 3.66602 0.647461 3.16504 0.647461C2.56738 0.647461 1.96973 0.911133 1.45117 1.41211C0.572266 2.23828 0.185547 3.2666 0.185547 4.40039C0.185547 6.97559 2.16309 10.0957 4.75586 12.6885Z",
    fill: "#043293"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonefill);
export default __webpack_public_path__ + "static/media/phone.fill.62bc60f0ce5efcd7ce0a2595ac480313.svg";
export { ForwardRef as ReactComponent };